var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showSpinner
    ? _c("spinner-loader", { attrs: { path: true } })
    : _c(
        "div",
        { staticClass: "interstitial-container", attrs: { id: "page" } },
        [
          _c(
            "b-row",
            { staticClass: "mx-0 header justify-content-center" },
            [
              _c(
                "b-col",
                {
                  staticClass: "my-auto text-center",
                  attrs: { lg: "6", sm: "9", cols: "11" },
                },
                [
                  _c("h2", { staticClass: "mb-3" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t("subdomain-interstitial.selectAnApplication")
                        ) +
                        "\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("h6", { staticClass: "grey-text text-darken-1" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t(
                            "subdomain-interstitial.selectApplicationFromList"
                          )
                        ) +
                        "\n      "
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.loading
            ? _c("subdomain-interstitial-loader")
            : _c(
                "b-row",
                { staticClass: "mx-0 justify-content-center interstitial-row" },
                [
                  _c("b-col", { attrs: { lg: "6", sm: "9", cols: "11" } }, [
                    _c(
                      "div",
                      { staticClass: "card interstitial-card" },
                      [
                        _c("interstitial-navbar", {
                          attrs: {
                            "tied-brokerages": _vm.tiedBrokerages,
                            "selected-brokerage": _vm.selectedBrokerageId,
                            "last-broker-name-by-brokerage":
                              _vm.lastBrokerNameByBrokerage,
                          },
                          on: {
                            "update:selectedBrokerage": function ($event) {
                              _vm.selectedBrokerageId = $event
                            },
                            "update:selected-brokerage": function ($event) {
                              _vm.selectedBrokerageId = $event
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("interstitial-applications", {
                          attrs: {
                            subdomains: _vm.APPLICATIONS_BY_SUBDOMAIN,
                            "selected-application-id":
                              _vm.selectedApplicationId,
                            "selected-subdomain": _vm.selectedSubdomain,
                          },
                          on: {
                            "update:selectedApplicationId": function ($event) {
                              _vm.selectedApplicationId = $event
                            },
                            "update:selected-application-id": function (
                              $event
                            ) {
                              _vm.selectedApplicationId = $event
                            },
                            "update:selectedSubdomain": function ($event) {
                              _vm.selectedSubdomain = $event
                            },
                            "update:selected-subdomain": function ($event) {
                              _vm.selectedSubdomain = $event
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "card-footer text-right" },
                          [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "text-primary font-weight-bold btn float-left clickable",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleGoToDashboard()
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t("sidebar.sections.dashboard")
                                    ) +
                                    "\n          "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                attrs: { id: "new-app" },
                                on: { click: _vm.handleNewAppModal },
                              },
                              [
                                _vm._v(
                                  "\n            + " +
                                    _vm._s(
                                      _vm.$t(
                                        "application.actions.addNewApplication"
                                      )
                                    ) +
                                    "\n          "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "simple-button",
                              {
                                attrs: {
                                  id: "action-button",
                                  loading: _vm.selectingApplication.loading,
                                  "loading-succeeded":
                                    _vm.selectingApplication.loadingSucceeded,
                                  disabled: _vm.$v.$invalid,
                                },
                                on: { click: _vm.handleSelectApplication },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t(
                                        "subdomain-interstitial.selectApplication"
                                      )
                                    ) +
                                    "\n          "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("new-app-modal", { ref: "newApplicationModal" }),
                            _vm._v(" "),
                            _c("start-app-modal", {
                              ref: "startApplicationModal",
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }